import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-create-biller',
  templateUrl: './create-biller.component.html',
  styleUrls: ['./create-biller.component.scss']
})
export class CreateBillerComponent implements OnInit {

  sent = false;

  form: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl('')
  });

  constructor(private httpClient: HttpClient, private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
  }

  send() {
    let biller = {
      name: this.form.value.name
    };
    this.httpClient.post('/api/billers',biller, {
      headers: new HttpHeaders().append('Authorization','Bearer ' + this.authService.token)
    }).subscribe((result: any) => {
      this.sent = true;
    });
  }

  back() {
    this.router.navigate(['/']);
  }

}
